import React, { useState, useEffect, ReactNode } from 'react';

interface DelayedRenderProps {
  children: ReactNode;
  delay: number; // Delay in milliseconds
  onRenderDelay?: number;
  fallback?: ReactNode; // Optional fallback content to show during delay
  onRender?: () => void;
}

export const DelayedRender: React.FC<DelayedRenderProps> = ({
  children,
  delay = 300,
  onRenderDelay = 0,
  fallback = null,
  onRender,
}) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
      setTimeout(() => {
        onRender?.();
      }, onRenderDelay);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  if (!shouldRender) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
